import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './FooterSection.css';

const FooterSection = () => {
  return (
    <footer className="footer-dev">
      <Container className="contiene-footer">
        <Row>
          <Col md={12}>
            <p className="leyenda-footer">
              <strong>AlexDev</strong> - <em>Desarrollo Web y Estrategias de Social Media Profesional</em> - <strong>Pasión y Compromiso</strong>
            </p>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <p className="mb-0 derechos">© 2023 Todos los derechos reservados. Diseñado y desarrollado por Alexis Ramos.</p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}

export default FooterSection;
